<!-- <p>dashboard-rules works!</p> -->
<div class="main-div">
    <div class="title-table">
        <div class="title">
            <span>{{panelData ? panelData.title : "Rules"}}</span>
            <mat-icon *ngIf="creating && panelData" [matMenuTriggerFor]="titleMenu" [matMenuTriggerData]="{panelData: panelData}">edit</mat-icon>
            </div>
        <table mat-table [dataSource]="dataSource" matSort [matSortDirection]="'asc'"
            [matSortActive]="'RuleDescription'">
            <ng-container matColumnDef="RuleDescription" *ngIf="rules">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Rule Name </th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row"
                    (click)="GoToRule(row)">
                    {{row.RuleDescription}} </td>
            </ng-container>
            <ng-container matColumnDef="condition" *ngIf="rules">
                <th mat-header-cell *matHeaderCellDef> Condition </th>
                <td style="cursor: pointer;" mat-cell *matCellDef="let row" (click)="GoToRule(row)">
                    {{row.ReadableRule}} </td>
            </ng-container>
            <ng-container matColumnDef="AssetName" style="cursor: pointer;">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Asset</th>
                <td style="cursor: pointer;" mat-cell *matCellDef="let row" (click)="GoToRule(row)"> {{
                    row.AssetName }}
                </td>
            </ng-container>
            <ng-container matColumnDef="LastTriggered" style="cursor: pointer;">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Triggered</th>
                <td style="cursor: pointer;" mat-cell *matCellDef="let row" (click)="GoToRule(row)">
                    <span *ngIf="row.LastTriggered == 0">Never</span>
                    <span *ngIf="row.LastTriggered > 0">{{ convertEpoch(row.LastTriggered) }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="EventsInPast30Days" style="cursor: pointer;">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Events In Past 30 Days</th>
                <td style="cursor: pointer;" mat-cell *matCellDef="let row" (click)="GoToRule(row)">
                    <span *ngIf="row.EventsInPast30Days == 0">No Events</span>
                    <span *ngIf="row.EventsInPast30Days > 0">{{ row.EventsInPast30Days }}</span>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row class="table-row" [ngStyle]="{'color': !row.RuleEnabled ? 'grey' : ''}"
                [ngClass]="{'active-rule': row.Active}" *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td>No Rules Found</td>
            </tr>
        </table>
    </div>
</div>